import {
  Popover2InteractionKind as BlueprintPopover2InteractionKind,
  Tooltip2 as BlueprintTooltip2,
  Tooltip2Props as BlueprintTooltip2Props,
} from '@blueprintjs/popover2';
import classNames from 'classnames';
import * as React from 'react';

import { Body } from 'bones/design-system/components/typography/Body';
import { Heading } from 'bones/design-system/components/typography/Heading';

export type TooltipProps = Omit<
  BlueprintTooltip2Props,
  'className' | 'content'
> & {
  'data-testid'?: never;
  description?: string;
  slot?: React.ReactNode;
  testId?: string;
  title?: string;
};

export const Tooltip: React.VFC<TooltipProps> = ({
  children,
  description,
  popoverClassName,
  slot,
  targetProps,
  testId,
  title,
  ...props
}) => (
  <BlueprintTooltip2
    content={
      <>
        {title ? (
          <Heading className="vb-tooltip-title" size="md" weight="semibold">
            {title}
          </Heading>
        ) : null}
        {description ? (
          <Body className="vb-tooltip-description" size="sm">
            {description}
          </Body>
        ) : null}
        {slot}
      </>
    }
    data-testid={testId}
    hoverCloseDelay={100}
    interactionKind={BlueprintPopover2InteractionKind.HOVER}
    popoverClassName={classNames(popoverClassName, 'vb-tooltip')}
    portalContainer={
      (process.env.NODE_ENV === 'test' &&
        document.getElementById('vet-bones-root')) ||
      // istanbul ignore next
      undefined
    }
    targetProps={{
      ...targetProps,
      className: classNames(
        targetProps?.className,
        'vb-tooltip-popover-target'
      ),
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {
      // fragment is required since popover supports only having one child
    }
    <>{children}</>
  </BlueprintTooltip2>
);
